var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "basic-container",
    [
      _c("div", { staticClass: "query-form-wrap" }, [
        _c(
          "div",
          { staticClass: "query-form-wrap-left" },
          [
            _c(
              "el-form",
              { attrs: { inline: true, model: _vm.searchForm, size: "small" } },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "媒资名称" } },
                  [
                    _c("el-input", {
                      attrs: { clearable: "", placeholder: "请输入媒资名称" },
                      model: {
                        value: _vm.searchForm.name,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "name", $$v)
                        },
                        expression: "searchForm.name",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "状态" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { clearable: "", placeholder: "全部" },
                        model: {
                          value: _vm.searchForm.status,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "status", $$v)
                          },
                          expression: "searchForm.status",
                        },
                      },
                      _vm._l(_vm.status, function (item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "方式" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { clearable: "", placeholder: "全部" },
                        model: {
                          value: _vm.searchForm.initialType,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "initialType", $$v)
                          },
                          expression: "searchForm.initialType",
                        },
                      },
                      _vm._l(_vm.initialType, function (item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { span: 20 } },
                  [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "auth",
                            rawName: "v-auth",
                            value: "MARKMANAGE_HOTLIST_SEARCH",
                            expression: "'MARKMANAGE_HOTLIST_SEARCH'",
                          },
                        ],
                        attrs: {
                          icon: "el-icon-search",
                          size: "small",
                          type: "primary",
                        },
                        on: { click: _vm.handleSearch },
                      },
                      [_vm._v("搜索")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { icon: "el-icon-delete", size: "small" },
                        on: { click: _vm.handleClear },
                      },
                      [_vm._v("清空")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        [
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "primary" },
              on: { click: _vm.handleAdd },
            },
            [_vm._v("新增")]
          ),
        ],
        1
      ),
      _c("br"),
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.handleTabClick },
          model: {
            value: _vm.searchForm.mediaType,
            callback: function ($$v) {
              _vm.$set(_vm.searchForm, "mediaType", $$v)
            },
            expression: "searchForm.mediaType",
          },
        },
        [
          _c("el-tab-pane", { attrs: { label: "电视剧", name: 1 } }),
          _c("el-tab-pane", { attrs: { label: "电影", name: 2 } }),
          _c("el-tab-pane", { attrs: { label: "少儿", name: 4 } }),
          _c("el-tab-pane", { attrs: { label: "综艺", name: 3 } }),
        ],
        1
      ),
      _c("br"),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: { data: _vm.hotListData, border: "", height: "500" },
        },
        [
          _c("el-table-column", {
            attrs: { type: "index", width: "50", label: "序号" },
          }),
          _c("el-table-column", {
            attrs: { prop: "coverImage", width: "100", label: "媒资图片" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (data) {
                  return [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "justify-content": "center",
                          "align-items": "center",
                        },
                      },
                      [
                        _vm.isShowIframe
                          ? _c("ImageIframe", {
                              staticStyle: { width: "75px", height: "100px" },
                              attrs: { url: data.row.coverImage },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { width: "100", prop: "name", label: "媒资名称" },
          }),
          _c("el-table-column", {
            attrs: { width: "80", prop: "type", label: "媒资类型" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (data) {
                  return [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.valueToLabel(_vm.typeOptions, data.row.type)
                        ) +
                        "\n            "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { width: "80", prop: "hotval", label: "热度值" },
          }),
          _c("el-table-column", {
            attrs: { width: "50", prop: "status", label: "状态" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (data) {
                  return [
                    _c("span", { class: { gary: data.row.status === 2 } }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.valueToLabel(_vm.statusOptions, data.row.status)
                          )
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { width: "50", prop: "initialType", label: "方式" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (data) {
                  return [
                    _c("span", { class: { red: data.row.initialType === 2 } }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.valueToLabel(
                              _vm.initTypeOptions,
                              data.row.initialType
                            )
                          )
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { width: "120", label: "播放源" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (data) {
                  return [
                    _c("div", [
                      data.row.payType[0]
                        ? _c("div", [_vm._v(_vm._s(data.row.payType[0]))])
                        : _vm._e(),
                      data.row.payType[1]
                        ? _c("div", [_vm._v(_vm._s(data.row.payType[1]))])
                        : _vm._e(),
                      data.row.payType[2]
                        ? _c("div", [_vm._v(_vm._s(data.row.payType[2]))])
                        : _vm._e(),
                      !data.row.payType[0] &&
                      !data.row.payType[1] &&
                      !data.row.payType[2]
                        ? _c("div", [
                            _vm._v(
                              "\n                        暂无播放源\n                    "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "媒资标签" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (data) {
                  return [
                    _c(
                      "el-popover",
                      {
                        attrs: {
                          placement: "top-start",
                          trigger: "hover",
                          content: data.row.tagName,
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "white-space": "nowrap",
                              overflow: "hidden",
                              "text-overflow": "ellipsis",
                            },
                            attrs: { slot: "reference" },
                            slot: "reference",
                          },
                          _vm._l(data.row.tagName.split(","), function (item) {
                            return _c(
                              "el-tag",
                              {
                                key: item.id,
                                staticStyle: { "margin-right": "10px" },
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(item) +
                                    "\n                        "
                                ),
                              ]
                            )
                          }),
                          1
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "description",
              label: "媒资简介",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: { prop: "updateTime", label: "最后更新时间", width: "180" },
          }),
          _c("el-table-column", {
            attrs: { label: "操作" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "auth",
                            rawName: "v-auth",
                            value: "MARKMANAGE_HOTLIST_CANCEL",
                            expression: "'MARKMANAGE_HOTLIST_CANCEL'",
                          },
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              scope.row.initialType === 2 &&
                              scope.row.status === 1,
                            expression:
                              "scope.row.initialType === 2 && scope.row.status === 1",
                          },
                        ],
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.cancelIntervention(scope.row)
                          },
                        },
                      },
                      [_vm._v("取消人工干预")]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "auth",
                            rawName: "v-auth",
                            value: "MARKMANAGE_HOTLIST_EDIT",
                            expression: "'MARKMANAGE_HOTLIST_EDIT'",
                          },
                        ],
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.handleEdit(scope.row, scope.$index)
                          },
                        },
                      },
                      [_vm._v("编辑")]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "auth",
                            rawName: "v-auth",
                            value: "MARKMANAGE_HOTLIST_VIEW",
                            expression: "'MARKMANAGE_HOTLIST_VIEW'",
                          },
                        ],
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.handleView(scope.row)
                          },
                        },
                      },
                      [_vm._v("查看")]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "auth",
                            rawName: "v-auth",
                            value: "MARKMANAGE_HOTLIST_STATE",
                            expression: "'MARKMANAGE_HOTLIST_STATE'",
                          },
                          {
                            name: "show",
                            rawName: "v-show",
                            value: scope.row.status === 2,
                            expression: "scope.row.status === 2",
                          },
                        ],
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.handlePuton(scope.row, _vm.index)
                          },
                        },
                      },
                      [_vm._v("上架")]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "auth",
                            rawName: "v-auth",
                            value: "MARKMANAGE_HOTLIST_STATE",
                            expression: "'MARKMANAGE_HOTLIST_STATE'",
                          },
                          {
                            name: "show",
                            rawName: "v-show",
                            value: scope.row.status === 1,
                            expression: "scope.row.status === 1",
                          },
                        ],
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.handleTokeOff(scope.row, _vm.index)
                          },
                        },
                      },
                      [_vm._v("下架")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.isEdit ? "编辑" : "查看",
            visible: _vm.viewDialog,
            width: "60%",
            "modal-append-to-body": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.viewDialog = $event
            },
            closed: function ($event) {
              _vm.isEdit = false
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "viewForm",
              attrs: { model: _vm.viewForm, rules: _vm.rules },
            },
            [
              _vm.isEdit
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "sortNo",
                        label: "人工排序:",
                        "label-width": "20%",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          "show-word-limit": "",
                          maxlength: "50",
                          type: "textarea",
                          autosize: { minRows: 2, maxRows: 8 },
                          placeholder: "请输入排序",
                        },
                        model: {
                          value: _vm.viewForm.sortNo,
                          callback: function ($$v) {
                            _vm.$set(_vm.viewForm, "sortNo", _vm._n($$v))
                          },
                          expression: "viewForm.sortNo",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "mediaAsset.name",
                    label: "媒资名称:",
                    "label-width": "20%",
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      "show-word-limit": "",
                      disabled: _vm.disabled,
                      maxlength: "50",
                      type: "textarea",
                      autosize: { minRows: 2, maxRows: 8 },
                      placeholder: "请输入媒资名称",
                    },
                    model: {
                      value: _vm.viewForm.mediaAsset.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.viewForm.mediaAsset, "name", $$v)
                      },
                      expression: "viewForm.mediaAsset.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "mediaAsset.aliasName",
                    label: "媒资别名:",
                    "label-width": "20%",
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      "show-word-limit": "",
                      disabled: _vm.disabled,
                      maxlength: "50",
                      type: "textarea",
                      autosize: { minRows: 2, maxRows: 8 },
                      placeholder: _vm.viewForm.mediaAsset.aliasName
                        ? _vm.viewForm.mediaAsset.aliasName
                        : "暂无媒资别名",
                    },
                    model: {
                      value: _vm.viewForm.mediaAsset.aliasName,
                      callback: function ($$v) {
                        _vm.$set(_vm.viewForm.mediaAsset, "aliasName", $$v)
                      },
                      expression: "viewForm.mediaAsset.aliasName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "mediaAsset.type",
                    label: "媒资类型:",
                    "label-width": "20%",
                  },
                },
                [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.valueToLabel(
                          _vm.typeOptions,
                          _vm.viewForm.mediaAsset.type
                        )
                      )
                    ),
                  ]),
                ]
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "drama.episodes",
                    label: "集数:",
                    "label-width": "20%",
                  },
                },
                [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.viewForm.drama.episodes
                          ? _vm.viewForm.drama.episodes
                          : "集数未知"
                      )
                    ),
                  ]),
                ]
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "mediaAsset.description",
                    label: "简介:",
                    "label-width": "20%",
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      "show-word-limit": "",
                      disabled: _vm.disabled,
                      maxlength: "500",
                      type: "textarea",
                      autosize: { minRows: 2, maxRows: 8 },
                      placeholder: "请输入简介",
                    },
                    model: {
                      value: _vm.viewForm.mediaAsset.description,
                      callback: function ($$v) {
                        _vm.$set(_vm.viewForm.mediaAsset, "description", $$v)
                      },
                      expression: "viewForm.mediaAsset.description",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "mediaAsset",
                    label: "简介:",
                    "label-width": "20%",
                  },
                },
                [
                  _c("div", { staticClass: "showMediaImg" }, [
                    _c(
                      "div",
                      { staticClass: "showMediaImg-left" },
                      [
                        _c("span", [_vm._v("封面图: ")]),
                        _vm.viewForm.mediaAsset.isShowCoverImage
                          ? _c("ImageIframe", {
                              attrs: {
                                url: _vm.viewForm.mediaAsset.coverImage,
                              },
                            })
                          : _vm._e(),
                        !_vm.viewForm.mediaAsset.coverImage
                          ? _c("span", [_vm._v("暂无图片")])
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "showMediaImg-right" },
                      [
                        _c("span", [_vm._v("高清横屏图: ")]),
                        _vm.viewForm.mediaAsset.isShowHdImage
                          ? _c("ImageIframe", {
                              attrs: { url: _vm.viewForm.mediaAsset.hdImage },
                            })
                          : _vm._e(),
                        !_vm.viewForm.mediaAsset.hdImage
                          ? _c("span", [_vm._v("暂无图片")])
                          : _vm._e(),
                        _c(
                          "el-upload",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.disabled,
                                expression: "!disabled",
                              },
                            ],
                            staticClass: "upload-demo",
                            attrs: {
                              "before-upload": _vm.checkUpload,
                              "http-request": _vm.upload,
                              listType: "picture-img",
                              action: "hdImage",
                              "on-preview": _vm.handlePreview,
                              "on-remove": _vm.handleRemove,
                              "before-remove": _vm.beforeRemove,
                              "on-exceed": _vm.handleExceed,
                              "show-file-list": false,
                            },
                          },
                          [
                            _c(
                              "el-button",
                              { attrs: { size: "small", type: "primary" } },
                              [_vm._v("重新上传")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ]
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "mediaAsset.score",
                    label: "评分:",
                    "label-width": "20%",
                  },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.viewForm.mediaAsset.score) +
                      "\n            "
                  ),
                ]
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "mediaAsset.url",
                    label: "页面访问地址:",
                    "label-width": "20%",
                  },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.viewForm.mediaAsset.url) +
                      "\n            "
                  ),
                ]
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "mediaAsset.urlScheme",
                    label: "app跳转地址:",
                    "label-width": "20%",
                  },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.viewForm.mediaAsset.urlScheme) +
                      "\n            "
                  ),
                ]
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "mediaAsset.tagName",
                    label: "备注:",
                    "label-width": "20%",
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      "show-word-limit": "",
                      disabled: _vm.disabled,
                      maxlength: "99",
                      type: "textarea",
                      autosize: { minRows: 2, maxRows: 8 },
                      placeholder: _vm.viewForm.mediaAsset.tagName
                        ? _vm.viewForm.mediaAsset.tagName
                        : "暂无备注",
                    },
                    model: {
                      value: _vm.viewForm.mediaAsset.tagName,
                      callback: function ($$v) {
                        _vm.$set(_vm.viewForm.mediaAsset, "tagName", $$v)
                      },
                      expression: "viewForm.mediaAsset.tagName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "mediaAsset.sourceType",
                    label: "来源平台:",
                    "label-width": "20%",
                  },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.valueToLabel(
                          _vm.sourcePlatformOptions,
                          _vm.viewForm.mediaAsset.sourceType
                        )
                      ) +
                      "\n            "
                  ),
                ]
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    width: "100%",
                    "max-height": "31.25rem",
                    overflow: "auto",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "staffMembers",
                        label: "明星列表:",
                        "label-width": "20%",
                      },
                    },
                    [
                      _vm.viewForm.staffMembers.length
                        ? _c(
                            "div",
                            { staticClass: "showMediaImg" },
                            _vm._l(_vm.viewForm.staffMembers, function (item) {
                              return _c(
                                "div",
                                {
                                  key: item.id,
                                  staticClass: "showMediaImg-left",
                                },
                                [
                                  _vm.viewForm.mediaAsset.isShowActorImage
                                    ? _c("ImageIframe", {
                                        attrs: { url: item.headImage },
                                      })
                                    : _vm._e(),
                                  !item.headImage
                                    ? _c("span", [_vm._v("暂无图片")])
                                    : _vm._e(),
                                  _c("p", [
                                    _vm._v("演员：" + _vm._s(item.name)),
                                  ]),
                                  _c(
                                    "p",
                                    {
                                      staticStyle: { "margin-top": "-1.25rem" },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                职务：" +
                                          _vm._s(
                                            _vm.valueToLabel(
                                              _vm.actorDutyOptions,
                                              item.position
                                            )
                                          ) +
                                          "\n                            "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            }),
                            0
                          )
                        : _c("div", [
                            _vm._v(
                              "\n                        暂无数据\n                    "
                            ),
                          ]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    width: "100%",
                    "max-height": "31.25rem",
                    overflow: "auto",
                    "margin-top": "3.125rem",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "剧集列表:", "label-width": "20%" } },
                    [
                      _c(
                        "el-table",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { data: _vm.viewForm.episodes, border: "" },
                        },
                        [
                          _c("el-table-column", {
                            attrs: { prop: "episodeName", label: "集名" },
                          }),
                          _c("el-table-column", {
                            attrs: { prop: "duration", label: "时长" },
                          }),
                          _c("el-table-column", {
                            attrs: { prop: "url", label: "页面访问地址" },
                          }),
                          _c("el-table-column", {
                            attrs: { prop: "urlScheme", label: "app跳转地址" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isEdit,
                  expression: "isEdit",
                },
              ],
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.editDialogCancel } }, [
                _vm._v("取 消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.editDialogConfirm },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "新增媒资",
            visible: _vm.addDialog,
            width: "60%",
            "modal-append-to-body": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.addDialog = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "query-form-wrap-left",
              staticStyle: { "margin-top": "-30px" },
            },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    inline: true,
                    model: _vm.addSearchForm,
                    size: "small",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "媒资名称" } },
                    [
                      _c("el-input", {
                        attrs: { clearable: "", placeholder: "请输入媒资名称" },
                        model: {
                          value: _vm.addSearchForm.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.addSearchForm, "name", $$v)
                          },
                          expression: "addSearchForm.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "媒资资源" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "全部" },
                          model: {
                            value: _vm.addSearchForm.type,
                            callback: function ($$v) {
                              _vm.$set(_vm.addSearchForm, "type", $$v)
                            },
                            expression: "addSearchForm.type",
                          },
                        },
                        _vm._l(_vm.type, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { span: 20 } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { icon: "el-icon-search", type: "primary" },
                          on: { click: _vm.handleAddSearch },
                        },
                        [_vm._v("搜索")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { icon: "el-icon-delete" },
                          on: { click: _vm.handleAddClear },
                        },
                        [_vm._v("清空")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form",
            {
              ref: "addDataForm",
              staticStyle: { "margin-top": "-20px" },
              attrs: {
                size: "small",
                model: _vm.addDataForm,
                rules: _vm.addDataRules,
              },
            },
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%", "margin-top": "1.25rem" },
                  attrs: {
                    height: "400",
                    data: _vm.addData,
                    "row-key": "id",
                    border: "",
                  },
                  on: { "selection-change": _vm.selectMedia },
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "exist", width: "50" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-radio",
                              {
                                attrs: {
                                  disabled: scope.row.exist,
                                  label: scope.row,
                                },
                                on: { input: _vm.selectMedia },
                                model: {
                                  value: _vm.isChecked,
                                  callback: function ($$v) {
                                    _vm.isChecked = $$v
                                  },
                                  expression: "isChecked",
                                },
                              },
                              [_vm._v(" \n                        ")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { width: "80", label: "媒资图片" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "justify-items": "center",
                                  "align-items": "center",
                                },
                              },
                              [
                                _c("ImageIframe", {
                                  staticStyle: {
                                    width: "75px",
                                    height: "100px",
                                  },
                                  attrs: { url: scope.row.coverImage },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { width: "150", prop: "name", label: "媒资名称" },
                  }),
                  _c("el-table-column", {
                    attrs: { width: "80", prop: "type", label: "媒资类型" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (data) {
                          return [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.valueToLabel(
                                    _vm.typeOptions,
                                    data.row.type
                                  )
                                ) +
                                "\n                    "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { width: "150", label: "排序" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-form-item",
                              { attrs: { label: " ", prop: scope.row.id } },
                              [
                                _c("el-input", {
                                  attrs: { disabled: scope.row.exist },
                                  model: {
                                    value: scope.row.sortNo,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "sortNo", $$v)
                                    },
                                    expression: "scope.row.sortNo",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      width: "200",
                      prop: "sourceType",
                      label: "播放源",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (data) {
                          return [
                            _c("div", [
                              data.row.payType[0]
                                ? _c("div", [
                                    _vm._v(_vm._s(data.row.payType[0])),
                                  ])
                                : _vm._e(),
                              data.row.payType[1]
                                ? _c("div", [
                                    _vm._v(_vm._s(data.row.payType[1])),
                                  ])
                                : _vm._e(),
                              data.row.payType[2]
                                ? _c("div", [
                                    _vm._v(_vm._s(data.row.payType[2])),
                                  ])
                                : _vm._e(),
                              !data.row.payType[0] &&
                              !data.row.payType[1] &&
                              !data.row.payType[2]
                                ? _c("div", [
                                    _vm._v(
                                      "\n                                暂无播放源\n                            "
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "tagName", label: "媒资标签" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "el-popover",
                              {
                                attrs: {
                                  placement: "top-start",
                                  width: "200",
                                  trigger: "hover",
                                  content: row.tagName,
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      width: "300px",
                                      "margin-bottom": "5px",
                                      "white-space": "nowrap",
                                      overflow: "hidden",
                                      "text-overflow": "ellipsis",
                                    },
                                    attrs: { slot: "reference" },
                                    slot: "reference",
                                  },
                                  _vm._l(
                                    row.tagName.split(","),
                                    function (item) {
                                      return _c(
                                        "el-tag",
                                        {
                                          key: item.id,
                                          staticStyle: {
                                            "margin-right": "10px",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(item) +
                                              "\n                                "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  1
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { width: "100", label: "操作" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: { size: "small", type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleGetDetail(row, _vm.index)
                                  },
                                },
                              },
                              [_vm._v("查看")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "pagination",
              staticStyle: {
                "text-align": "right",
                "margin-top": "1.25rem",
                display: "flex",
                "justify-content": "space-between",
              },
            },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.addSearchForm.current,
                  "page-sizes": [10, 20, 30, 40],
                  "page-size": _vm.addSearchForm.size,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.addSearchForm.total,
                },
                on: {
                  "size-change": _vm.handleAddSizeChange,
                  "current-change": _vm.handleAddCurrentChange,
                },
              }),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c("el-button", { on: { click: _vm.handleAddCancel } }, [
                    _vm._v("取 消"),
                  ]),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleAddConfirm },
                    },
                    [_vm._v("确 定")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("br"),
      _c(
        "div",
        { staticClass: "pagination", staticStyle: { "text-align": "right" } },
        [
          _c("ElementPagination", {
            attrs: {
              "current-page": _vm.searchForm.current,
              "page-size": _vm.searchForm.size,
              total: _vm.searchForm.total,
              "page-sizes": [10, 20, 30, 40, 50],
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _c("br"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }